export const FORM_STATUS_OPTIONS = [
  { name: 'Active', value: 'Active' },
  { name: 'Inactive', value: 'Inactive' },
];

export const FORM_TYPE_OPTIONS = [
  { name: 'Commitment Non-Serialized', value: 'Commitment Non-Serialized' },
  { name: 'CPL', value: 'CPL' },
  { name: 'CPL serialize', value: 'CPL serialize' },
  { name: 'Endorsement FACC', value: 'Endorsement FACC' },
  { name: 'Jacket', value: 'Policy' },
];

export const COVERAGE_CLASS_OPTIONS = [
  { name: 'Full', value: 'Full' },
  { name: 'Limited', value: 'Limited' },
  { name: 'None', value: 'None' },
  { name: 'Other', value: 'Other' },
];

export const POLICY_TYPE_OPTIONS = [
  { name: 'Owner', value: 'OWNER' },
  { name: 'Lender', value: 'LENDER' },
  { name: 'Guarantee', value: 'GUARANTEE' },
];

export const UNDERWRITER_OPTIONS = [
  { name: 'FATIC', value: 'FATIC' },
  { name: 'FATIC-KS', value: 'FATIC-KS' },
  { name: 'FATIC-NY', value: 'FATIC-NY' },
  { name: 'FATIC-OR', value: 'FATIC-OR' },
  { name: 'FATTX', value: 'FATTX' },
  { name: 'PLT', value: 'PLT' },
  { name: 'OBT', value: 'OBT' },
  { name: 'MG', value: 'MG' },
  { name: 'UGTIC', value: 'UGTIC' },
  { name: 'TAT', value: 'TAT' },
  { name: 'FATIC-LA', value: 'FATIC-LA' },
  { name: 'FATGC', value: 'FATGC' },
];

export const US_STATE_OPTIONS = [
  { name: 'Alabama', value: 'AL' },
  { name: 'Alaska', value: 'AK' },
  { name: 'Arizona', value: 'AZ' },
  { name: 'Arkansas', value: 'AR' },
  { name: 'California', value: 'CA' },
  { name: 'Colorado', value: 'CO' },
  { name: 'Connecticut', value: 'CT' },
  { name: 'Delaware', value: 'DE' },
  { name: 'Florida', value: 'FL' },
  { name: 'Georgia', value: 'GA' },
  { name: 'Hawaii', value: 'HI' },
  { name: 'Idaho', value: 'ID' },
  { name: 'Illinois', value: 'IL' },
  { name: 'Indiana', value: 'IN' },
  { name: 'Iowa', value: 'IA' },
  { name: 'Kansas', value: 'KS' },
  { name: 'Kentucky', value: 'KY' },
  { name: 'Louisiana', value: 'LA' },
  { name: 'Maine', value: 'ME' },
  { name: 'Maryland', value: 'MD' },
  { name: 'Massachusetts', value: 'MA' },
  { name: 'Michigan', value: 'MI' },
  { name: 'Minnesota', value: 'MN' },
  { name: 'Mississippi', value: 'MS' },
  { name: 'Missouri', value: 'MO' },
  { name: 'Montana', value: 'MT' },
  { name: 'Nebraska', value: 'NE' },
  { name: 'Nevada', value: 'NV' },
  { name: 'New Hampshire', value: 'NH' },
  { name: 'New Jersey', value: 'NJ' },
  { name: 'New Mexico', value: 'NM' },
  { name: 'New York', value: 'NY' },
  { name: 'North Carolina', value: 'NC' },
  { name: 'North Dakota', value: 'ND' },
  { name: 'Ohio', value: 'OH' },
  { name: 'Oklahoma', value: 'OK' },
  { name: 'Oregon', value: 'OR' },
  { name: 'Pennsylvania', value: 'PA' },
  { name: 'Rhode Island', value: 'RI' },
  { name: 'South Carolina', value: 'SC' },
  { name: 'South Dakota', value: 'SD' },
  { name: 'Tennessee', value: 'TN' },
  { name: 'Texas', value: 'TX' },
  { name: 'Utah', value: 'UT' },
  { name: 'Vermont', value: 'VT' },
  { name: 'Virginia', value: 'VA' },
  { name: 'Washington', value: 'WA' },
  { name: 'West Virginia', value: 'WV' },
  { name: 'Wisconsin', value: 'WI' },
  { name: 'Wyoming', value: 'WY' },
  { name: 'District of Columbia', value: 'DC' },
];
